module.exports = __webpack_public_path__ + "static/Ruth-038181ae9f03f0582de30246ddc0086b.png";